import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { dashboardServices } from "../../../../service/dashboard";
import translationData from '../../../../locales/dashboardTranslation.json'
import { historicalServices } from "../../../../service/historicalDashboard";



interface AutoclaveDetailsLayoutProps {
  heading: string;
  selectedDate: any;
}

const columnStyle = {
  margin: "0 0 6px 0",
  // borderBottom: '0.5px solid rgba(0, 0, 0, 0.11)'
};

const lastColumnStyle = {
  margin: "0",
};
const AutoclaveDetailsLayout: React.FC<AutoclaveDetailsLayoutProps> = ({
  heading,
  selectedDate,
}) => {

  interface ColumnData {
    id: number;
    apiName: string;
    displayName: string;
    count: number;
  }
  const [columnsData, setColumnsData] = useState<ColumnData[]>([]);
  const navigate = useNavigate();

  const navigateToOtherPage = () => {
    navigate('/autoclave-history-table'); 
  };

  const switchToPage = (id: number) => {
  }

  const getAutoclaveStatus = async () => {
    try {
      const response = await historicalServices.getAutoclaveStatus(selectedDate.startDate, selectedDate.endDate, selectedDate.building,selectedDate.plant,selectedDate.unit,selectedDate.parentArea);
      if (response.status && response.statusCode === 200) {
        try {
          const responseData = response.data;
          if (responseData) {
            setColumnsData(prevColumnsData => {
              return prevColumnsData.map(column => {
                const { apiName, displayName } = column;

                const apiCount = responseData[apiName];

                if (apiCount !== undefined) {
                  return { ...column, count: apiCount };
                } else {
                  console.warn(`API response for ${displayName} is undefined or missing.`);
                  return column;
                }
              });
            });
          }
        } catch (error) {
          console.log(error);
        }
      }
    } catch (error) {
      console.error('user response', error);
    }
  };

  useEffect(() => {
    const AutoclaveDataHead = translationData.HistoryAutoclaveHead;
    setColumnsData(AutoclaveDataHead.map((item => ({ ...item, count: 0 }))));
    }, []); 

  useEffect(() => {
    getAutoclaveStatus();
  }, [selectedDate])

  return (
    <div className="container">
      <h2 className="head-style" title="Click here to View AutoClave Details" onClick={navigateToOtherPage}>
        {heading}
      </h2>
      <div className="columns" style={{ padding: "10px" }}>
          {columnsData.map((column) => (
          <div key={column.id} className="column" style={column.id === columnsData.length ? lastColumnStyle : columnStyle}>
          <div className="linkStyle" onClick={() => switchToPage(column.id)}>
          <span className= 'column-style'>
            {column.displayName}
          </span>
          <span className="countStyle">{column.count}</span>
          </div>
          </div>
          ))}
      </div>
    </div>
  );
};

export default AutoclaveDetailsLayout;